import queryString from 'query-string';
import React, { Component } from 'react';
import 'sweetalert2/src/sweetalert2.scss';
import Alert from '../../assets/images/alert-icon.png';
import { ReactComponent as HomeFooter } from '../../assets/images/home-footer.svg';
import MovieInfo from '../../components/MovieInfo/MovieInfo';
import BookingSummary from '../../components/BookingSummary';
import * as API from '../../configuration/apiconfig';
import Header from '../../components/Header';
import { calculateHoursAndMinutes, formatFilmShowDate, formatShowTime } from '../../utils/DateTimeFormat';
import { handlePrintTicketUtil, getAllPayloads, calculateTotal } from '../../utils/printUtils';
import './index.scss';
import { showAlert } from '../../components/showAlert';
import { ReactComponent as AlertIcon } from '../../assets/images/alert-icon.svg';
import { ReactComponent as AccordionDownArrow } from '../../assets/images/accordion-down-arrow.svg';

class index extends Component {
  constructor(props) {
    super(props);
    let pathName = typeof window !== 'undefined' ? window.location.search : '';
    const parsedQueryString = queryString.parse(pathName);
    this.state = {
      status: parsedQueryString.status,
      idFromQueryParam: parsedQueryString.id,
      paymentidFromQueryParam: parsedQueryString.paymentid,
      bookingSummary: {},
      filmsData: {
        images: [],
        title: '',
        subtitle: '',
        language: '',
        genres: '',
        rating: '',
        runtime: '',
        screenName: '',
        experiences: '',
        timing: '',
        seats: [],
        showtime: '',
      },
      showdate: '',
      formattedShowtime: '',
      cinemaName: '',
      bookingid: '',
      ticketsSummary: [],
      ticketsDataForTicketSummary: [],
      fnbDataForTicketSummary: [],
      orderType: localStorage.getItem('orderType'),
      pickupNumber: '',
      paymentsTypes: [],

      setRedeemcardData: {},
    };
  }

  componentDidMount() {
    window.winvar = this;
    this.handleOrderConfirmation();
    localStorage.removeItem('endTimeInSecs');
    localStorage.removeItem('BookingCountdown');
    localStorage.setItem('orderFlowCompleted', 'true');
    localStorage.getItem('ageRestrictionValidation') != null && localStorage.removeItem('ageRestrictionValidation');
    this.props.timerInConfirmationPageDecrement();
  }

  handleOrderConfirmation = async () => {
    var orderUrl = '';
    if (this.state.status === 'success') {
      orderUrl = `/order/v2/bookings?id=${this.state.idFromQueryParam}&paymentid=${this.state.paymentidFromQueryParam}&status=${this.state.status}`;
    } else {
      orderUrl = `/order/v2/orders?id=${this.state.idFromQueryParam}`;
    }

    const orderRes = await API.callEndpoint('GET', 'Bearer', orderUrl)
      .then(response => {
        return response.data[0];
      })
      .catch(error => {
        console.log(error, 'error');
        showAlert({
          html: `<p>${error.error}</p>`,
          iconHtml: <AlertIcon />,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          allowEscapeKey: false,
          iconClasses: 'borderless',
          onConfirm: () => {
            window.location.href = `/?cinemaid=${localStorage.getItem('cinemaid')}`;
          },
        });
      });
    console.log(orderRes, 'order response');
    if (!orderRes) return;
    this.setState(
      {
        bookingSummary: orderRes,
        filmsData:
          this.state.orderType == 'ticketing' && orderRes.film && Object.keys(orderRes.film).length > 0
            ? {
                title: orderRes.film.films_attributes[0].title,
                subtitle: orderRes.film.films_attributes[0].subtitle,
                language: orderRes.film.films_attributes[0].language,
                genres: orderRes.film.films_genres.flatMap(({ description }) => (description.trim() !== '' ? [description.trim()] : [])),
                rating: orderRes.film.rating,
                runtime: orderRes.film.runtime,
                screenName: orderRes.session.cinemas_screens[0].name,
                images: orderRes.film.films_images,
                experiences: orderRes.session.sessions_experiences.map(item => item.name).join(', '),
                seats: orderRes.order_grouping.flatMap(({ seats }) => seats.split(', ')),
                timing: formatFilmShowDate(orderRes.showdate),
                showTime: formatShowTime(orderRes.showtime),
              }
            : {},
        formattedShowtime: this.state.orderType == 'ticketing' && orderRes.showtime != null && formatShowTime(orderRes.showtime),
        cinemaName: orderRes.cinema.cinemas_attributes[0].name,
        bookingid: orderRes.bookingid,
        pickupNumber: orderRes.pickupNumber,
      },
      () => {
        if (this.state.status == 'success') {
          this.ticketsSummary();
          this.setTicketsDataForTicketSummary();
          this.setFnbDataForTicketSummary();
          this.setGiftcardForTicketSummary();

          this.setLoyaltycardData();
        }
      }
    );
  };

  setLoyaltycardData = async () => {
    const { bookingSummary } = this.state;
    if (Object.keys(bookingSummary).length > 0 && bookingSummary.bookings_paymenttypes.length > 0) {
      var getLoyaltyObj = bookingSummary.bookings_paymenttypes.find(x => x.type.toLowerCase() == 'loyaltycard');
      console.log(getLoyaltyObj, 'getLoyaltyObj--payment');
      if (getLoyaltyObj) {
        this.setState({
          setRedeemcardData: getLoyaltyObj,
        });
      }
    }
  };

  ticketsSummary = async () => {
    let ticketDetails = [];
    let subTotal = 0;
    let taxValue = 0;

    this.state.bookingSummary.order_grouping?.map(ticket => {
      ticketDetails.push({
        description: ticket.description,
        quantity: ticket.quantity,
        valueBeforeTax: ticket.pricebeforetax,
      });
      subTotal = subTotal + ticket.pricebeforetax;
    });

    const tcktSummaryObj = {
      ticketDetails: ticketDetails,
      // subTotal: subTotal + bookingFeeBeforeTax,
      subTotal: this.state.bookingSummary.valuebeforetax,
      taxValue: this.state.bookingSummary.taxValue,
      grandTotal: this.state.bookingSummary.remainingOrderValue,
      bookingFee: this.state.bookingSummary.bookingfeebeforetax,
    };

    this.setState({ ticketsSummary: [tcktSummaryObj] }, () => {
      console.log(this.state.ticketsSummary);
      // Directly use the shared utility to print
      handlePrintTicketUtil({
        bookingSummary: this.state.bookingSummary,
        ticketsSummary: this.state.ticketsSummary,
        ticketsDataForTicketSummary: this.state.ticketsDataForTicketSummary,
        fnbDataForTicketSummary: this.state.fnbDataForTicketSummary,
        getAllPayloadsFn: getAllPayloads,
        calculateTotalFn: calculateTotal,
        formatShowTimeFn: formatShowTime,
        windowObj: window,
        constantObj: window.constant,
      });
    });
  };

  setTicketsDataForTicketSummary = () => {
    let tempOrderData = [];
    this.state.bookingSummary.order_grouping.map(eachTicket => {
      if (eachTicket.type.toLowerCase() == 'ticket') {
        let eachTaxValue = eachTicket.taxValue / eachTicket.quantity;
        let tempTicketObject = {
          description: eachTicket.description,
          unitprice: eachTicket.unitprice - eachTaxValue,
          qty: eachTicket.quantity,
        };
        if (window.constant.ENABLE_VOUCHERS === 'true') {
          console.log('REACT_APP_ENABLE_VOUCHERS');
          const currentItemCode = eachTicket.code;
          console.log('currentItemCode: ', currentItemCode);
          var orderinfoTickets = this.state.bookingSummary.orderinfo;
          console.log('orderinfoTickets: ', orderinfoTickets);
          var filterTicketsBasedOnCode = orderinfoTickets.tickets.filter(x => x.code == currentItemCode);
          console.log('filterTicketsBasedOnCode: ', filterTicketsBasedOnCode);
          if (filterTicketsBasedOnCode.length > 0) {
            var voucherCodeArr = [];
            filterTicketsBasedOnCode.map(item => {
              item?.voucherCode && voucherCodeArr.push(item.voucherCode);
            });
            console.log('voucherCodeArr: ', voucherCodeArr);
            tempTicketObject.voucherCode = voucherCodeArr.length > 0 ? voucherCodeArr.toString() : '';
          }
        }
        tempOrderData.push(tempTicketObject);
      }
    });
    this.setState({
      ticketsDataForTicketSummary: tempOrderData,
    });
  };

  setFnbDataForTicketSummary = () => {
    var fnbDataForTicketSummary = [];
    this.state.bookingSummary.order_grouping.map(eachItem => {
      if (eachItem.type.toLowerCase() == 'fnb') {
        var tempItemObject = {
          description: eachItem.description,
          qty: eachItem.quantity,
          unitprice: eachItem.unitprice - eachItem.taxValue / eachItem.quantity,
          modifiers: [],
          smartModifiers: [],
          inSeatDelivery: eachItem.additionalInfo.inSeatDelivery,
          pickupAtCounter: eachItem.additionalInfo.pickupAtCounter,
        };

        eachItem.additionalInfo.modifiers.map(eachModifier => {
          var tempModifierObject = {
            description: eachModifier.description,
            qty: eachModifier.quantity,
            unitprice: eachModifier.pricebeforetax / eachModifier.quantity,
          };
          tempItemObject.modifiers.push(tempModifierObject);
          tempItemObject.unitprice = tempItemObject.unitprice - eachModifier.pricebeforetax;
        });

        if (window.constant.ENABLE_VOUCHERS === 'true') {
          if (eachItem.additionalInfo.voucherCode && eachItem.additionalInfo.voucherCode.length > 0) {
            var voucherCodeArr = eachItem.additionalInfo.voucherCode;
            tempItemObject.voucherCode = voucherCodeArr.toString();
          }
        }

        fnbDataForTicketSummary.push(tempItemObject);
      }
    });
    this.setState({
      fnbDataForTicketSummary,
    });
  };

  nextBtnClick = () => {
    console.log('nextbtn click');
  };

  setGiftcardForTicketSummary = () => {
    var tempBookingSummary = this.state.bookingSummary;
    if (Object.keys(tempBookingSummary).length > 0 && tempBookingSummary.bookings_paymenttypes.length > 0) {
      this.setState({
        paymentsTypes: tempBookingSummary.bookings_paymenttypes,
      });
    }
  };

  render() {
    const hasVerticalScrollbar = window.document.documentElement.scrollHeight + 200 > window.document.documentElement.clientHeight;
    return (
      <section className={`confirmation-summary ${this.state.orderType == 'fnb' ? 'confirmation-fnb-flow' : ''}`}>
        <section className={`${this.state.status === 'success' ? 'success-container' : 'failure-container'}`}>
          <Header logo={true} homeIcon={true} timer={false} />
          <MovieInfo filmsData={this.state.filmsData} orderStatus={this.state.status} isConfirmationPageBanner={true} hideMovieBg={this.state.orderType == 'ticketing' ? false : true} />
          <section className={`${this.state.status === 'success' ? 'success-wrap' : 'failure-wrap'}`}>
            {this.state.status === 'success' && (
              <div className="booking-wrap">
                {this.state.orderType == 'ticketing' ? (
                  <div className="booking-id">
                    Booking ID:<span>{this.state.bookingid}</span>
                  </div>
                ) : (
                  <>
                    <div className="booking-id">
                      Pickup No: <span>#{this.state.pickupNumber}</span>
                    </div>
                    <div className="food-counter">
                      <p>Please view the display at the food counter</p>
                    </div>
                  </>
                )}
              </div>
            )}
            {this.state.filmsData && Object.keys(this.state.filmsData).length > 0 && this.state.filmsData.seats.length > 0 && (
              <MovieInfo
                filmsData={this.state.filmsData}
                selectedSeats={this.state.bookingSummary?.orders_items?.length > 0 ? this.state.bookingSummary.orders_items : this.state.bookingSummary.order_grouping}
                isSeatLayoutPage={true}
                hideMovieBg={true}
                isConfirmationPageBanner={false}
              />
            )}
            {this.state.status === 'failure' && (
              <div className="transaction-fail">
                <AlertIcon alt="Alert Icon" />
                <p>Your transaction could not be completed with details provided.</p>
                <p>Please approach a member of our staff at the box office.</p>
              </div>
            )}
            {this.state.status === 'success' && (
              <div className="bookingSummary">
                <div className="accordion" id="confirmation-accordion">
                  <div className="accordion-item">
                    <p className="bookingSummaryHeading accordion-header" id="confirmation-heading">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#confirmation-collaspse1"
                        aria-expanded="false"
                        aria-controls="confirmation-collaspse"
                      >
                        Booking Summary
                        <AccordionDownArrow />
                      </button>
                      <div className="separator"></div>
                    </p>
                    <div
                      id="confirmation-collaspse1"
                      className={`accordion-collapse collapse ${hasVerticalScrollbar ? '' : 'show'}`}
                      aria-labelledby="confirmation-heading"
                      data-bs-parent="#confirmation-accordion"
                    >
                      <div className="accordion-body">
                        <BookingSummary
                          ticketsDataForTicketSummary={this.state.ticketsDataForTicketSummary}
                          fnbDataForTicketSummary={this.state.fnbDataForTicketSummary}
                          incDecItem={false}
                          nextBtnClick={this.nextBtnClick}
                          nextBtnText={''}
                          bookingFee={this.state.bookingSummary.bookingfeebeforetax}
                          tax={this.state.bookingSummary.taxValue}
                          paymentsTypes={this.state.paymentsTypes}
                          setRedeemcardData={this.state.setRedeemcardData}
                        ></BookingSummary>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* P1 - Remove the Reprint option */}
            {/*{
            this.state.status === "success" && (
              <div className="print-blk" id="print-btn">
                <a onClick={() => this.printTicketsBtnClick('printBtn')} href="javascript:;" className="btn btnPrimary" title="PRINT TICKETS">PRINT TICKETS</a>
              </div>)
            } */}

            <div className="home-wrap">
              <a href={`/?cinemaid=${localStorage.getItem('cinemaid')}`} className="home-link-wrap">
                {/* <img src={HomeFooter} alt="Home Logo" className="home-logo" /> */}
                <HomeFooter className="home-logo" />
                <span className="home-link">GO HOME</span>
              </a>
            </div>
          </section>
        </section>
      </section>
    );
  }
}

export default index;
